import { proxy } from "valtio";

export const onlineStatus = proxy({
  isOnline: typeof navigator !== "undefined" ? navigator.onLine : true,
  lastChecked: Date.now(),
  lastSuccess: Date.now(),
});
